import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { Auth } from '@angular/fire/auth';
import { BrandContextService } from '../services/brand-context.service';
import { SKIP_BRAND_SCOPE, isBrandScopeExcluded } from './brand-scope';

function brandHeader(brandContext: BrandContextService, req: Parameters<HttpInterceptorFn>[0]): Record<string, string> {
  const brandId = !req.context.get(SKIP_BRAND_SCOPE) && !isBrandScopeExcluded(req.url)
    ? brandContext.currentBrandId()
    : null;
  return brandId ? { 'X-Brand-Id': brandId } : {};
}

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  // inject() must run synchronously in the interceptor's own call, not inside the async
  // switchMap callback below (no injection context there).
  const auth = inject(Auth, { optional: true });
  const brandContext = inject(BrandContextService);
  const user = auth?.currentUser ?? null;

  if (!user) {
    const cloned = req.clone({ setHeaders: brandHeader(brandContext, req) });
    return next(cloned);
  }

  return from(user.getIdToken()).pipe(
    switchMap(token => {
      const cloned = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          ...brandHeader(brandContext, req)
        }
      });
      return next(cloned);
    })
  );
};
